module.exports = __webpack_public_path__ + "assets/ipgeolocation.d3eb6f9c.svg";